module.exports = __webpack_public_path__ + "static/media/marioPic.b16dda21.png";